import Vue from 'vue'
import Vuex from 'vuex'
import * as formApi from '@/api/form'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    dict: {}
  },
  getters: {
  },
  mutations: {
    SET_DICT: (state, [name, value]) => {
      Vue.set(state.dict, name, value)
    }
  },
  actions: {
    getPersonCategory ({ commit }) {
      return new Promise((resolve) => {
        formApi.personCategory().then(res => {
          commit('SET_DICT', ['personCategory', [
            { value: '', label: '全部' },
            ...res.data.map(e => ({ value: e, label: e }))
          ]])
        }).finally(() => {
          resolve()
        })
      })
    },
    getBiographieName ({ commit }) {
      return new Promise((resolve) => {
        formApi.biographieName().then(res => {
          commit('SET_DICT', ['biographieName', [
            { value: '', label: '全部' },
            ...res.data.map(e => ({ value: e, label: e }))
          ]])
        }).finally(() => {
          resolve()
        })
      })
    },
    getAllSect ({ commit }) {
      return new Promise((resolve) => {
        formApi.allSect().then(res => {
          commit('SET_DICT', ['allSect', [
            { value: '', label: '全部' },
            ...res.data.map(e => ({ value: e, label: e }))
          ]])
        }).finally(() => {
          resolve()
        })
      })
    },
    getAllDynasty ({ commit }) {
      return new Promise((resolve) => {
        formApi.allDynasty().then(res => {
          commit('SET_DICT', ['allDynasty', [
            { value: '', label: '全部' },
            ...res.data.map(e => ({ value: e, label: e }))
          ]])
        }).finally(() => {
          resolve()
        })
      })
    }
  },
  modules: {
  }
})
